import { HTMLAttributes } from 'react'
import { StyledSegmentControl, StyledSegmentControls } from './styles'
import { EditorPanelSwitcherItem, EditorPanelSwitcherTheme } from './types'

type Props<T extends string> = {
  isMobileModal?: boolean
  activePanelType?: T
  items: EditorPanelSwitcherItem<T>[]
  handlePanelTypeChange?: (type: T) => void
  theme?: EditorPanelSwitcherTheme
  isFullWidth?: boolean
} & HTMLAttributes<HTMLDivElement>

export const EditorPanelSwitcher = <T extends string>(props: Props<T>) => {
  const {
    isMobileModal,
    activePanelType,
    handlePanelTypeChange,
    items,
    theme = 'default',
    isFullWidth = true,
    ...rest
  } = props

  const onSegmentClick = (type: T) => {
    if (type !== activePanelType) {
      handlePanelTypeChange?.(type)
    }
  }

  return (
    <StyledSegmentControls $theme={theme} {...rest}>
      {items.map(item => (
        <StyledSegmentControl
          key={item.id}
          id={`mobile-${isMobileModal ? 'modal-' : ''}${item.id}-button`}
          onClick={() => onSegmentClick(item.id)}
          $isActive={activePanelType === item.id}
          data-highlight-id={item.highlightId}
          $theme={theme}
          $isFullWidth={isFullWidth}
          data-testid={item.dataTestId}
        >
          {item.text}
        </StyledSegmentControl>
      ))}
    </StyledSegmentControls>
  )
}
